export const ShortcutKeyMap = {
	SAVE: "ctrl+s",
	OPEN: "ctrl+o",
	OPEN_COMMAND: "cmd+k|ctrl+k", // Support both Mac and PC
	COMMENT_MODE: "c",
	ESCAPE: "escape",
	ENTER: "enter",
}

export type ShortcutAction = keyof typeof ShortcutKeyMap
